//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum } from './Enums';

export class TeacherCalendarDisplayItem extends ItemBase {
    ID: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    Name: string | null = null;
    HasProfilePicture: boolean = false;
    ProfileHeadshotURL: string | null = null;
    Color: EventColorEnum = EventColorEnum.Beach;

    constructor(initializer?: Partial<TeacherCalendarDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherCalendarDisplayItem";
}
